import React, { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Box, Typography, Chip, IconButton, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles'
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined'

import { useCombos } from '../../../combos'
import { companyPanelStyles } from './company-panel.styles'

export const PORequests = withStyles(companyPanelStyles)(
  ({ classes, company, data = [], canNavigate = false }) => {
    const navigate = useNavigate()
    const { formatMessage: fm, formatDate: fd } = useIntl()
    const combos = useCombos(['estados_peticion_op'])
    const OP_STATES = { REJECTED: { key: '00', value: 'Rechazada' } }

    const handleNavigateToPORequest = useCallback(
      (opRequestId) => navigate(`/po-requests/${opRequestId}`),
      [] // eslint-disable-line react-hooks/exhaustive-deps
    )

    const handleNavigateToPORequestList = useCallback(() => {
      const props = {
        pathname: '/po-requests',
        search: company.nombre ? `?_search=${company.nombre}` : '',
      }
      return navigate(props)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getStateValue = (stateKey) => {
      const poRequestCombo = combos.estados_peticion_op?.data
      const stateValue = poRequestCombo.find((item) => item.key === stateKey)?.value
      return stateValue || stateKey
    }

    return useMemo(
      () => (
        <>
          <Box display="flex" alignItems="center" mb={3}>
            <Typography variant="h6" color="primary">
              {fm({ id: 'pages.eeii.detail.poRequests.title' })}
            </Typography>
            {canNavigate && data.length ? (
              <IconButton
                onClick={handleNavigateToPORequestList}
                style={{ marginLeft: 10 }}
                size="large">
                <ExitToAppOutlinedIcon />
              </IconButton>
            ) : null}
          </Box>
          {data.length ? (
            <Box>
              {data
                .sort((a, b) => new Date(b.dg_ts_insert) - new Date(a.dg_ts_insert))
                .map((item) => {
                  return (
                    <Box
                      key={item.id}
                      className={classes.poRow}
                      onClick={canNavigate ? () => handleNavigateToPORequest(item.id) : null}
                    >
                      <Box>
                        <Typography variant="subtitle1">{item.nombre}</Typography>
                        <div style={{ display: 'flex', gap:'16px', alignItems: 'center' }}>
                        <Typography variant="caption" color="textSecondary">
                          {fm(
                            { id: 'pages.eeii.detail.poRequests.fields.date.title' },
                            { date: fd(item.dg_ts_insert) }
                          )}
                        </Typography>
                          {item.firmante && (
                          <Typography variant="caption" color="textSecondary">
                            {fm(
                              { id: 'pages.eeii.detail.poRequests.fields.usuario.title' },
                              { usuario: item.firmante }
                            )}
                          </Typography> )}
                        </div>
                      </Box>

                      {item.estado === OP_STATES.REJECTED.key ? (
                        <Tooltip arrow title={item.observaciones_rechazo}>
                          <Box>
                            <Chip clickable size="small" label={getStateValue(item.estado)} />
                          </Box>
                        </Tooltip>
                      ) : (
                        <Box>
                          <Chip clickable size="small" label={getStateValue(item.estado)} />
                        </Box>
                      )}
                    </Box>
                  )
                })}
            </Box>
          ) : (
            <Typography variant="body1" color="textSecondary" paragraph>
              {fm({ id: 'pages.eeii.detail.poRequests.noData' })}
            </Typography>
          )}
        </>
      ),
      [data] // eslint-disable-line react-hooks/exhaustive-deps
    );
  }
)
